module.exports = __webpack_public_path__ + "static/media/above-threshold.2b09bb2a.svg";